export default "/shWBTC.31833efff51985c90cd8ad20aa8b7ed2.svg";